import React, { useEffect, useState } from 'react';
import GuestyForm from './GuestyForm';
import LodgifyForm from './LodgifyForm';
import ClientInfoForm from './ClientInformation';
import AdminPages from './AdminPages';
import EditableTable from './table';
import QuoteCar from './test';

const clientIntegration = 'guesty';

const AdminForm = () => {
  //const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const SERVER_URL = process.env.REACT_APP_SERVER_URL

  {/*useEffect(() => {
    const fetchClientData = async () => {
      try {
        const response = await fetch(`${SERVER_URL}/api/getClient`);
        if (!response.ok) {
          throw new Error('Failed to fetch client data');
        }
        const data = await response.json();
        setClientData(data); // Store the fetched client data
      } catch (err) {
        setError(err.message); // Set error message
      } finally {
        setLoading(false); // Stop loading after fetching
      }
    };

    fetchClientData(); // Call the function to fetch data
  }, [])*/} // Empty dependency array to run once on mount

  return (
    <div className="container mx-auto p-2">
      <h1 className="text-3xl font-bold mb-6">Client Management for Beyond Booking Admin</h1>
      <div className="flex flex-col space-x-2">
        <div className="w-1/3">
          {loading ? (
            <p>Loading client data...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : (
            <>
            {/*<ClientInfoForm clientData={clientData} />*/} 
            </>
          )}
        </div>
        <div className="w-1/3">
          {/*clientIntegration === 'guesty' ? <GuestyForm clientData={clientData} /> : <LodgifyForm clientData={clientData} />*/}
        </div>
      </div>
      <QuoteCar/>
      <EditableTable/>
      {/*<AdminPages/>*/}
    </div>
  );
};

export default AdminForm;